window.addEventListener("DOMContentLoaded", function () {
  const initializeLeadListSearch = () => {
    const container = document.querySelector('.lead-list-search-container');
    if (!container) return;

    const searchInput = container.querySelector('.lead-list-search');
    const resultsContainer = container.querySelector('.lead-list-results');
    const hiddenInput = container.querySelector('input[type="hidden"]');
    
    if (!searchInput || !resultsContainer || !hiddenInput) return;

    let allLeadLists = [];
    try {
      allLeadLists = JSON.parse(container.dataset.leadLists || '[]');
    } catch (error) {
      console.error('Error parsing lead lists:', error);
      return;
    }

    console.log('Initializing lead list search with:', { 
      hiddenInputValue: hiddenInput.value,
      allLeadLists: allLeadLists
    });

    if (hiddenInput.value) {
      const selectedList = allLeadLists.find(([_, id]) => id.toString() === hiddenInput.value);
      if (selectedList) {
        searchInput.value = selectedList[0];
        console.log('Restored lead list selection:', selectedList);
      }
    }

    searchInput.addEventListener('focus', () => {
      if (!searchInput.value.trim()) {
        showResults(allLeadLists);
      }
    });

    const showResults = (results) => {
      resultsContainer.innerHTML = '';
      
      if (results.length === 0) {
        resultsContainer.style.display = 'none';
        return;
      }

      results.forEach((result) => {
        const div = document.createElement('div');
        div.className = 'lead-list-result';
        const [name, id] = result;
        div.textContent = name;
        div.addEventListener('click', () => {
          searchInput.value = name;
          hiddenInput.value = id;
          console.log('Selected lead list:', { name, id, hiddenValue: hiddenInput.value });
          resultsContainer.style.display = 'none';
        });
        resultsContainer.appendChild(div);
      });

      resultsContainer.style.display = 'block';
    };

    const filterLeadLists = (searchTerm) => {
      const term = searchTerm.toLowerCase().trim();
      
      if (!term) {
        showResults(allLeadLists);
        return;
      }

      const matchingResults = allLeadLists.filter((result) => {
        const [name] = result;
        return name.toLowerCase().includes(term);
      });

      showResults(matchingResults);

      if (matchingResults.length === 1 && 
          matchingResults[0][0].toLowerCase() === term) {
        const [name, id] = matchingResults[0];
        searchInput.value = name;
        hiddenInput.value = id;
        resultsContainer.style.display = 'none';
      }
    };

    searchInput.addEventListener('input', (e) => {
      filterLeadLists(e.target.value);
    });

    searchInput.addEventListener('paste', (e) => {
      setTimeout(() => {
        filterLeadLists(searchInput.value);
      }, 100);
    });

    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) {
        resultsContainer.style.display = 'none';
      }
    });
  };

  const initializeTcsConfigSearch = () => {
    const container = document.querySelector('.tcs-config-search-container');
    if (!container) return;

    const searchInput = container.querySelector('.tcs-config-search');
    const resultsContainer = container.querySelector('.tcs-config-results');
    const hiddenInput = container.querySelector('input[type="hidden"]');
    
    if (!searchInput || !resultsContainer || !hiddenInput) return;

    let allTcsConfigs = [];
    try {
      allTcsConfigs = JSON.parse(container.dataset.tcsConfigs || '[]');
    } catch (error) {
      console.error('Error parsing TCS configurations:', error);
      return;
    }

    console.log('Initializing TCS config search with:', { 
      hiddenInputValue: hiddenInput.value,
      allTcsConfigs: allTcsConfigs
    });

    if (hiddenInput.value) {
      const selectedConfig = allTcsConfigs.find(([_, id]) => id.toString() === hiddenInput.value);
      if (selectedConfig) {
        searchInput.value = selectedConfig[0];
        console.log('Restored TCS config selection:', selectedConfig);
      }
    }

    searchInput.addEventListener('focus', () => {
      if (!searchInput.value.trim()) {
        showResults(allTcsConfigs);
      }
    });

    const showResults = (results) => {
      resultsContainer.innerHTML = '';
      
      if (results.length === 0) {
        resultsContainer.style.display = 'none';
        return;
      }

      results.forEach((result) => {
        const div = document.createElement('div');
        div.className = 'tcs-config-result';
        const [name, id] = result;
        div.textContent = name;
        div.addEventListener('click', () => {
          searchInput.value = name;
          hiddenInput.value = id;
          console.log('Selected TCS config:', { name, id, hiddenValue: hiddenInput.value });
          resultsContainer.style.display = 'none';
        });
        resultsContainer.appendChild(div);
      });

      resultsContainer.style.display = 'block';
    };

    const filterTcsConfigs = (searchTerm) => {
      const term = searchTerm.toLowerCase().trim();
      
      if (!term) {
        showResults(allTcsConfigs);
        return;
      }

      const matchingResults = allTcsConfigs.filter((result) => {
        const [name] = result;
        return name.toLowerCase().includes(term);
      });

      showResults(matchingResults);

      if (matchingResults.length === 1 && 
          matchingResults[0][0].toLowerCase() === term) {
        const [name, id] = matchingResults[0];
        searchInput.value = name;
        hiddenInput.value = id;
        resultsContainer.style.display = 'none';
      }
    };

    searchInput.addEventListener('input', (e) => {
      filterTcsConfigs(e.target.value);
    });

    searchInput.addEventListener('paste', (e) => {
      setTimeout(() => {
        filterTcsConfigs(searchInput.value);
      }, 100);
    });

    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) {
        resultsContainer.style.display = 'none';
      }
    });
  };

  const setupFormSubmissionFix = () => {
    const forms = document.querySelectorAll('form');
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        const tcsContainer = form.querySelector('.tcs-config-search-container');
        if (tcsContainer) {
          const tcsHiddenInput = tcsContainer.querySelector('input[type="hidden"]');
          const tcsSearchInput = tcsContainer.querySelector('.tcs-config-search');
          
          if (tcsHiddenInput && tcsSearchInput && !tcsHiddenInput.value.trim() && tcsSearchInput.value.trim()) {
            try {
              const allTcsConfigs = JSON.parse(tcsContainer.dataset.tcsConfigs || '[]');
              const matchingConfig = allTcsConfigs.find(([name]) => 
                name.toLowerCase() === tcsSearchInput.value.toLowerCase().trim());
              
              if (matchingConfig) {
                tcsHiddenInput.value = matchingConfig[1];
                console.log('Fixed missing TCS config ID:', matchingConfig[1]);
              }
            } catch (error) {
              console.error('Error fixing TCS ID:', error);
            }
          }
        }

        const llContainer = form.querySelector('.lead-list-search-container');
        if (llContainer) {
          const llHiddenInput = llContainer.querySelector('input[type="hidden"]');
          const llSearchInput = llContainer.querySelector('.lead-list-search');
          
          if (llHiddenInput && llSearchInput && !llHiddenInput.value.trim() && llSearchInput.value.trim()) {
            try {
              const allLeadLists = JSON.parse(llContainer.dataset.leadLists || '[]');
              const matchingList = allLeadLists.find(([name]) => 
                name.toLowerCase() === llSearchInput.value.toLowerCase().trim());
              
              if (matchingList) {
                llHiddenInput.value = matchingList[1];
                console.log('Fixed missing Lead List ID:', matchingList[1]);
              }
            } catch (error) {
              console.error('Error fixing Lead List ID:', error);
            }
          }
        }

        console.log('Form submission values:', {
          tcsValue: form.querySelector('.tcs-config-search-container input[type="hidden"]')?.value,
          llValue: form.querySelector('.lead-list-search-container input[type="hidden"]')?.value
        });
      });
    });
  };

  initializeLeadListSearch();
  initializeTcsConfigSearch();
  setupFormSubmissionFix();

  const providersWithShorteners = [
    "SMS Edge",
    "Uptotel",
    "Text-box",
    "MMDS V2",
    "Txt Local",
    "SMS Studio",
    "MMDS V3",
  ];

  const smsServiceField = document.getElementById("campaign_sms_service");
  function toggleUseProviderShortener() {
    const smsServiceField = document.getElementById("campaign_sms_service");
    const providerShortener = document.getElementById("provider_shortener");
    const providerShortenerCheckbox = document.getElementById("campaign_use_provider_shortener");

    if (!smsServiceField || !providerShortener || !providerShortenerCheckbox) {
      console.warn("One or more elements are missing. Skipping toggle.");
      return;
    }

    const selectedProvider = smsServiceField.options[smsServiceField.selectedIndex].text;
    console.log("Selected provider:", selectedProvider);

    if (providersWithShorteners.includes(selectedProvider)) {
      providerShortener.style.display = "block";
      providerShortenerCheckbox.style.display = "inline";
    } else {
      providerShortenerCheckbox.checked = false;
      providerShortener.style.display = "none";
    }
  }

  if (smsServiceField) {
    smsServiceField.addEventListener("change", toggleUseProviderShortener);
    toggleUseProviderShortener();
  } else {
    console.warn("smsServiceField is missing. Cannot assign change handler.");
  }

  var ChangeTotalMessageBodyCount = function(count) {
    var totalMessageBody = document.getElementById('total_message_body');
    var totalMessageBodyCount = document.getElementById('total_message_body_count');
    var textarea = document.getElementById('campaign_message_body');
    
    if (totalMessageBodyCount) {
      totalMessageBodyCount.innerHTML = count + '/160';
    }
    
    if (count > 158) {
      if (totalMessageBody) totalMessageBody.style.color = '#a94442';
      if (totalMessageBodyCount) totalMessageBodyCount.style.color = '#a94442';
      if (totalMessageBodyCount) totalMessageBodyCount.style.textDecoration = 'underline';
      if (textarea) textarea.style.borderColor = '#a94442';
    } else {
      if (totalMessageBody) totalMessageBody.style.color = '#000';
      if (totalMessageBodyCount) totalMessageBodyCount.style.color = '#000';
      if (totalMessageBodyCount) totalMessageBodyCount.style.textDecoration = 'none';
      if (textarea) textarea.style.borderColor = '#000';
    }
  };

  var MessageBodyLength = function () {
    var messageBody = document.getElementById('campaign_message_body').value;
    fetch('/amazingly-hard-to-guess/admin/campaigns/calculate_message_length', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ message_body: messageBody })
    })
    .then(response => response.json())
    .then(data => {
      ChangeTotalMessageBodyCount(data.length);
    })
    .catch(error => console.error('Error:', error));
  };

  const messageBodyField = document.getElementById('campaign_message_body');
  if (messageBodyField) {
    MessageBodyLength();
    messageBodyField.addEventListener('input', MessageBodyLength);
  } else {
    console.warn("campaign_message_body is missing. Cannot assign input handler.");
  }

  const confirmCreateCampaign = () => {
    const createButton = document.getElementById('create_campaign_button');
    if (createButton) {
      createButton.removeAttribute('data-confirm');
      
      createButton.addEventListener('click', function(event) {
        const messageCountElement = document.getElementById('total_message_body_count');
        let messageLength = 0;
        
        if (messageCountElement) {
          const countText = messageCountElement.innerText || messageCountElement.textContent;
          const match = countText.match(/(\d+)\/160/);
          if (match && match[1]) {
            messageLength = parseInt(match[1], 10);
          }
        }
        
        const confirmMessage = 'Are you sure you want to create this Campaign? Message body characters count = ' + messageLength + '/160';
        
        if (!window.confirm(confirmMessage)) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }, true);
    }
  };

  confirmCreateCampaign();
});
